<div class="modal-header">
  <h3 class="dialog-title text-center">{{ 'Version History' | translate }}</h3>
</div>
<div mat-dialog-content>
  <div class="custom-theme-table mt-3">
    <div class="custom-scrollbar table-responsive outer-bordered-table">
      <table mat-table class="table table-striped" [dataSource]="dataSource">

        <tr class="mat-row" *matNoDataRow [ngClass]="{ 'loading-row': isLoading }">
          <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
            @if (isLoading) {
              {{ 'Loading...' | translate }}
            } @else {
              {{ 'No previous versions - This is the only version of this OEL.' | translate }}
            }
          </td>
        </tr>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="version-status-badge" [ngClass]="row.statusClass">{{ row.statusLabel | translate }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="oel">
          <th mat-header-cell *matHeaderCellDef>{{ 'OEL' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.oelValue ?? '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="effectiveStart">
          <th mat-header-cell *matHeaderCellDef>{{ 'Effective Start' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.effectiveStartDisplay ?? '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="effectiveEnd">
          <th mat-header-cell *matHeaderCellDef>{{ 'Effective End' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.effectiveEndDisplay ?? '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="source">
          <th mat-header-cell *matHeaderCellDef>{{ 'Source' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.sourceRef ?? '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="updatedBy">
          <th mat-header-cell *matHeaderCellDef>{{ 'Updated By' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.updatedByUserName ?? '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="updatedDate">
          <th mat-header-cell *matHeaderCellDef>{{ 'Updated Date' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row.dateUpdatedDisplay ?? '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
        [class.historical-version-row]="row.isHistorical"></tr>
      </table>
    </div>
  </div>
</div>
<div mat-dialog-actions class="createButton mt-2">
  <button class="btn modal-footer-btn cancel-modal-btn" (click)="close()">{{ 'Close' | translate }}</button>
</div>
